// Utilitaires couleur pour la personnalisation libre des cartes.

export function normalizeHex(v) {
  let h = String(v || "").trim().replace("#", "");
  if (/^[0-9a-fA-F]{3}$/.test(h)) h = h.split("").map((c) => c + c).join("");
  return /^[0-9a-fA-F]{6}$/.test(h) ? `#${h.toUpperCase()}` : null;
}

// mix hex avec une cible ("#FFFFFF" pour éclaircir, "#000000" pour assombrir), t entre 0 et 1.
export function mix(hex, target, t) {
  const a = parseInt(hex.slice(1), 16);
  const b = parseInt(target.slice(1), 16);
  const ch = (sh) => {
    const x = (a >> sh) & 255;
    const y = (b >> sh) & 255;
    return Math.round(x + (y - x) * t);
  };
  return `#${((ch(16) << 16) | (ch(8) << 8) | ch(0)).toString(16).padStart(6, "0").toUpperCase()}`;
}

// Dégradé premium à partir d'une couleur de base.
export function gradientFrom(hex) {
  return `linear-gradient(135deg, ${mix(hex, "#FFFFFF", 0.08)} 0%, ${mix(hex, "#000000", 0.28)} 100%)`;
}

// Luminance relative : choisit un texte lisible (blanc ou bleu nuit) sur la couleur.
export function readableOn(hex) {
  const n = parseInt(hex.slice(1), 16);
  const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.6 ? "#071A2D" : "#FFFFFF";
}
